// extracted by mini-css-extract-plugin
module.exports = {"EasyPenPackage":"_2PjnegRfMk2RRUXu4foNVA"};